import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminBookings() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/admin/bookings").then(({ data }) => setRows(data));
  }, []);
  return (
    <div data-testid="admin-bookings">
      <h1 className="font-display text-4xl text-ink mb-10">Bookings</h1>
      <div className="bg-bg-surface border border-edge overflow-x-auto">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-edge text-eyebrow text-ink-muted">
            <tr>
              <th className="px-4 py-3">Date</th>
              <th className="px-4 py-3">Service</th>
              <th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3">Phone</th>
              <th className="px-4 py-3">Pref. date</th>
              <th className="px-4 py-3 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-edge last:border-0">
                <td className="px-4 py-3 text-ink-muted">{r.created_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 text-ink">{r.service_slug}</td>
                <td className="px-4 py-3 text-ink">{r.customer_name}</td>
                <td className="px-4 py-3 text-ink-muted">{r.customer_email}</td>
                <td className="px-4 py-3 text-ink-muted">{r.phone}</td>
                <td className="px-4 py-3 text-ink-muted">{r.preferred_date}</td>
                <td className="px-4 py-3 text-right text-brand font-display text-lg">
                  £{r.amount?.toFixed(0)}
                </td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="7" className="px-4 py-10 text-center text-ink-muted">
                  No bookings yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
